export default __webpack_public_path__ + "static/media/batumbu.95b9636f.png";